export const EASE_IN_EXPO = 'cubic-bezier(0.95, 0.05, 0.795, 0.035)';
export const EASE_OUT_QUAD = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
export const EASE_OUT_CUBIC = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
export const EASE_OUT_EXPO = 'cubic-bezier(0.19, 1, 0.22, 1)';
export const EASE_IN_OUT_CUBIC = 'cubic-bezier(0.645, 0.045, 0.355, 1)';
